import { Directive } from '@angular/core';

@Directive({
  selector: '[appBomDetailsTitle]',
  standalone: true,
})
export class BomDetailsTitleDirective {
  constructor() {}
}

@Directive({
  selector: '[appBomDetailsExtraData]',
  standalone: true,
})
export class BomDetailsExtraDataDirective {
  constructor() {}
}
